define('views/user/register/financial/identityconfirmation',["backbone",
         "text!views/user/register/financial/identityconfirmation.html"
], function (Backbone, Template) {
    "use strict";
    return Backbone.View.extend({
        template: _.template(Template),
        events: {},
        tagName: "Section",
        initialize: function (options) {
            options = options || {};
        },
        render: function () {
            this.$el.html(this.template());
            return this;
        },
        addOne:function(){

        },
        addAll:function(){

        },
        close: function () {
        }
    });
});

